import { render, staticRenderFns } from "./LNotification.vue?vue&type=template&id=40ed0fdc"
import script from "./LNotification.vue?vue&type=script&lang=js"
export * from "./LNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports